<div class='agpr-quickEditContactSearch'>
    <ng-container
        [formGroup]="contactForm"
    >
        <div class="agpr-quickEditContactSearch-header">
            <h2 class="agpr-quickEditContactSearch-title">{{ 'Discover.targeting.panels.contact' | localize }}</h2>
            <agpr-dropdown
                [id]="'agpr_quickEditContactSearch_dropdown'"
                [options]="contactSearchParams"
                (change)="handleContactChange($event);"
                [showInput]="false"
                [disabled]="!contactSearchParams?.length"
                [replaceInputIcon]="'fa-regular fa-duotone fa-square-plus'"
            ></agpr-dropdown>
        </div>


        <!-- contact name -->
        @if (_searchParamsVisible?.contactIdsNames) {
            <div class="agpr-quickEditContactSearch-searchForm-section agpr-quickEditContactSearch-searchForm-section-morePadding">
                <agpr-delete-container
                    [key]="'contacts'"
                    (removeParam)="removeParam($event)"
                >
                    <agpr-autocomplete-chips
                        formControlName="contacts"
                        [id]="'targetingSearch.contactNames.includeExclude'"
                        header="Discover.targeting.searchFieldLabels.contact.names"
                        headerStyleClass="agpr-targetingSearch-fieldLabels"
                        placeholder="Discover.targeting.searchFieldLabels.contactNames.placeholder"
                        field="name"
                        [autocompleteOptions]="contactNameAutocompleteChipsOptions"
                    ></agpr-autocomplete-chips>
                </agpr-delete-container>
            </div>
        }

        <!-- keywords -->
        @if (_searchParamsVisible?.monitoringKeywords) {
            <div class="agpr-quickEditContactSearch-searchForm-section">
                <agpr-delete-container
                    [key]="'keywords'"
                    (removeParam)="removeParam($event)"
                >
                    <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                        <agpr-include-exclude-chips
                            formControlName="keywords"
                            id="targetingSearch.covering.includeExclude"
                            headerLabel="Discover.targeting.searchFieldLabels.monitoringKeywords"
                            placeholder="Discover.targeting.searchFieldLabels.monitoringKeywords.placeholder"
                            tooltip="Discover.targeting.searchFieldLabels.contact.monitoringKeywords.tooltip"
                            [chipValidations]="keywordValidators"
                            headingLevel="3"
                            [splitOnPattern]="splitOnPattern"
                        ></agpr-include-exclude-chips>
                        @if (
                            (previewCount >= MAX_SEARCH_SIZE && !previewLoading) &&
                            (keywords.include.length > 0 || keywords.exclude.length > 0 || keywords.includeAll?.length > 0)
                        ) {
                            <div class="agpr-targetingSearch-message">
                                <agpr-message [severity]="messageSeverity.warning">
                                    {{ 'Discover.targeting.searchFieldLabels.keywords.broad' | localize }}
                                </agpr-message>
                            </div>
                        }
                    </div>
                </agpr-delete-container>
            </div>
        }

        <!-- subjects -->
        @if (_searchParamsVisible?.subjects) {
            <div class="agpr-quickEditContactSearch-searchForm-section">
                <agpr-delete-container
                    [key]="'subjects'"
                    (removeParam)="removeParam($event)"
                >
                    <agpr-include-exclude-subject-chips
                        formControlName="subjects"
                        id="targetingSearch.coveringSubjects.includeExclude"
                        headerLabel="Discover.targeting.searchFieldLabels.coveringSubjects"
                        placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                        tooltip="Discover.targeting.searchFieldLabels.coveringSubjects.tooltip"
                        (browseAll)="showSubjectsBrowser(subjectKey.subjects, $event)"
                        headingLevel="3"
                    ></agpr-include-exclude-subject-chips>
                </agpr-delete-container>
            </div>
        }

        <!-- geographies -->
        @if (_searchParamsVisible?.geographies) {
            <div class="agpr-quickEditContactSearch-searchForm-section">
                <agpr-delete-container
                    [key]="'geographies'"
                    (removeParam)="removeParam($event)"
                >
                    <agpr-include-exclude-chips
                        formControlName="geographies"
                        id="targetingSearch.regions.includeExclude"
                        headerLabel="Discover.targeting.searchFieldLabels.regions"
                        placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                        tooltip="Discover.targeting.searchFieldLabels.contactRegions.tooltip"
                        labelLookupField="displayString"
                        [autocompleteOptions]="{
                            suggestionsFetcher: targetingGeographyService.searchGeographicLocationsWithAccountRestrictions.bind(targetingGeographyService),
                            customOptions: [noContentMessages['region']]
                        }"
                        [showIncludeAll]="false"
                        (browseAll)="showRegionBrowser(regionKey.geographies, $event)"
                        headingLevel="3"
                    ></agpr-include-exclude-chips>
                </agpr-delete-container>

                @if (geographies.errors?.['duplicateRegions']) {
                    <agpr-form-message id="targetingSearch_geographies_error">
                        {{ 'Discover.targeting.rhp.regionsConflictError' | localize }}
                    </agpr-form-message>
                }
            </div>
        }

        <!-- jobTitles -->
        @if (_searchParamsVisible?.jobTitles) {
            <div class="agpr-quickEditContactSearch-searchForm-section">
                <agpr-delete-container
                    [key]="'jobTitles'"
                    (removeParam)="removeParam($event)"
                >
                    <agpr-include-exclude-chips
                        formControlName="jobTitles"
                        id="targetingSearch.jobTitles.includeExclude"
                        headerLabel="Discover.targeting.searchFieldLabels.jobTitles"
                        placeholder="Discover.targeting.searchFieldLabels.jobTitles.placeholder"
                        [showIncludeAll]="false"
                        headingLevel="3"
                    ></agpr-include-exclude-chips>
                </agpr-delete-container>
            </div>
        }

        <!-- jobRoles -->
        @if (_searchParamsVisible?.jobRoles) {
            <div class="agpr-quickEditContactSearch-searchForm-section">
                <agpr-delete-container
                    [key]="'jobRoles'"
                    (removeParam)="removeParam($event)"
                >
                    <agpr-include-exclude-chips
                        formControlName="jobRoles"
                        id="targetingSearch.jobRoles.includeExclude"
                        headerLabel="Discover.targeting.searchFieldLabels.jobRoles"
                        placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                        labelLookupField="displayString"
                        [autocompleteOptions]="{
                            suggestionsFetcher: journodexEnumsService.jobRoleAutocomplete.bind(journodexEnumsService),
                            customOptions: [noContentMessages['jobRole']]
                        }"
                        (browseAll)="showJobRoleBrowser($event)"
                        headingLevel="3"
                    ></agpr-include-exclude-chips>
                </agpr-delete-container>
            </div>
        }

        <!-- languages -->
        @if (_searchParamsVisible?.languages) {
            <div class="agpr-quickEditContactSearch-searchForm-section">
                <agpr-delete-container
                    [key]="'languages'"
                    (removeParam)="removeParam($event)"
                >
                    <agpr-include-exclude-chips
                        formControlName="languages"
                        id="targetingSearch.languages.includeExclude"
                        headerLabel="Discover.targeting.searchFieldLabels.languages"
                        placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                        labelLookupField="name"
                        [autocompleteOptions]="{
                            suggestionsFetcher: localizationService.autocompleteLanguages.bind(localizationService),
                            customOptions: [noContentMessages['language']]
                        }"
                        (browseAll)="showLanguageBrowser($event)"
                        headingLevel="3"
                    ></agpr-include-exclude-chips>
                </agpr-delete-container>
            </div>
        }

        @if (contactParamsEmpty) {
            <div class="agpr-quickEditContactSearch-searchForm-empty">
                <agpr-message
                    [severity]="messageSeverities.noContent"
                    [style]="agprComponentStyle.social"
                >
                    {{ 'Discover.recommendedRecipients.quickEdit.empty' | localize:{ 'section': 'Discover.targeting.panels.contact' } }}
                </agpr-message>
            </div>
        }

        <div class="agpr-quickEditContactSearch-header">
            <h2 class="agpr-quickEditContactSearch-title">{{ 'Discover.targeting.panels.outletFields' | localize }}</h2>
            <agpr-dropdown
                [id]="'agpr_quickEditOutletSearch_dropdown'"
                [options]="outletSearchParams"
                (change)="handleOutletChange($event);"
                [disabled]="!outletSearchParams?.length"
                [showInput]="false"
                [replaceInputIcon]="'fa-regular fa-duotone fa-square-plus'"
            ></agpr-dropdown>
        </div>

        <div
            class="agpr-targetingSearch-outletFields"
            formGroupName="employment"
        >
            <!-- outlet name -->
            @if (_searchParamsVisible?.outletIdsNames) {
                <div class="agpr-quickEditContactSearch-searchForm-section agpr-quickEditContactSearch-searchForm-section-morePadding">
                    <agpr-delete-container
                        [key]="'outlets'"
                        (removeParam)="removeParamOutlook($event)"
                    >
                        <agpr-autocomplete-chips
                            formControlName="outlets"
                            [id]="'targetingSearch.outletNames.includeExclude'"
                            header="Discover.targeting.searchFieldLabels.outlet.names"
                            headerStyleClass="agpr-targetingSearch-fieldLabels"
                            placeholder="Discover.targeting.searchFieldLabels.outletNames.placeholder"
                            [autocompleteOptions]="outletNameAutocompleteOptions"
                            field="name"
                        ></agpr-autocomplete-chips>
                    </agpr-delete-container>
                </div>
            }

            <!-- outlet keyword -->
            @if (_searchParamsVisible?.outletMonitoringKeywords) {
                <div class="agpr-quickEditContactSearch-searchForm-section">
                    <agpr-delete-container
                        [key]="'outletKeywords'"
                        (removeParam)="removeParamOutlook($event)"
                    >
                        <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                            <agpr-include-exclude-chips
                                formControlName="outletKeywords"
                                id="targetingSearch.outletMonitoringKeywords.includeExclude"
                                headerLabel="Discover.targeting.searchFieldLabels.monitoringKeywords"
                                tooltip="Discover.targeting.searchFieldLabels.contact.outletMonitoringKeywords.tooltip"
                                placeholder="Discover.targeting.searchFieldLabels.monitoringKeywords.placeholder"
                                [chipValidations]="keywordValidators"
                                [splitOnPattern]="splitOnPattern"
                            ></agpr-include-exclude-chips>
                        </div>
                    </agpr-delete-container>

                    @if (
                        (previewCount >= MAX_SEARCH_SIZE && !previewLoading) &&
                        (outletKeywords.include.length > 0 || outletKeywords.exclude.length > 0 || outletKeywords.includeAll?.length > 0)
                    ) {
                        <div class="agpr-targetingSearch-message">
                            <agpr-message
                                [severity]="messageSeverity.warning"
                            >
                                {{ 'Discover.targeting.searchFieldLabels.keywords.broad' | localize }}
                            </agpr-message>
                        </div>
                    }
                </div>
            }

            <!-- outlet subjects -->
            @if (_searchParamsVisible?.outletSubjects) {
                <div class="agpr-quickEditContactSearch-searchForm-section">
                    <agpr-delete-container
                        [key]="'outletSubjects'"
                        (removeParam)="removeParamOutlook($event)"
                    >
                        <agpr-include-exclude-subject-chips
                            formControlName="outletSubjects"
                            id="targetingSearch.objectCovering.includeExclude"
                            headerLabel="Discover.targeting.searchFieldLabels.coveringSubjects"
                            tooltip="Discover.targeting.searchFieldLabels.coveringSubjects.tooltip"
                            placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                            (browseAll)="showSubjectsBrowser(subjectKey.outletSubjects, $event)"
                        ></agpr-include-exclude-subject-chips>
                    </agpr-delete-container>
                </div>
            }

            <!-- areasOfCoverage -->
            @if (_searchParamsVisible?.areasOfCoverage) {
                <div class="agpr-quickEditContactSearch-searchForm-section">
                    <agpr-delete-container
                        [key]="'areasOfCoverage'"
                        (removeParam)="removeParamOutlook($event)"
                    >
                        <agpr-include-exclude-chips
                            formControlName="areasOfCoverage"
                            id="targetingSearch.areasOfCoverage.includeExclude"
                            headerLabel="Discover.targeting.searchFieldLabels.targetAudienceRegion"
                            tooltip="Discover.targeting.searchFieldLabels.contactTargetAudienceRegion.tooltip"
                            placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                            labelLookupField="displayString"
                            [autocompleteOptions]="{
                                suggestionsFetcher: targetingGeographyService.searchGeographicLocationsWithAccountRestrictions.bind(targetingGeographyService),
                                customOptions: [noContentMessages['targetAudienceRegion']]
                            }"
                            (browseAll)="showRegionBrowser(regionKey.areasOfCoverage, $event)"
                        ></agpr-include-exclude-chips>
                    </agpr-delete-container>
                </div>
            }

            <!-- mediaMarkets -->
            @if (_searchParamsVisible?.mediaMarkets) {
                <div class="agpr-quickEditContactSearch-searchForm-section">
                    <agpr-delete-container
                        [key]="'mediaMarkets'"
                        (removeParam)="removeParamOutlook($event)"
                    >
                        <agpr-include-exclude-media-market-chips
                            formControlName="mediaMarkets"
                            id="targetingSearch.mediaMarkets.includeExclude"
                            headerLabel="Discover.targeting.searchFieldLabels.mediaMarkets"
                            tooltip="Discover.targeting.searchFieldLabels.mediaMarkets.tooltip"
                            placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                            labelLookupField="displayString"
                            (browseAll)="openMediaMarketDialog($event)"
                        ></agpr-include-exclude-media-market-chips>
                    </agpr-delete-container>
                </div>
            }

            @if (outletParamsEmpty) {
                <div class="agpr-quickEditContactSearch-searchForm-empty">
                    <agpr-message
                        [severity]="messageSeverities.noContent"
                        [style]="agprComponentStyle.social"
                    >
                        {{ 'Discover.recommendedRecipients.quickEdit.empty' | localize:{ 'section': 'Discover.targeting.panels.outletFields' } }}
                    </agpr-message>
                </div>
            }
        </div>
    </ng-container>
</div>
